// Check if the element is hidden by checking if it or any of its parents has a display: none or visibility: hidden or opacity: 0 style
export const isElementHidden = (element: HTMLElement): boolean => {
  let currentElement: HTMLElement | null = element;
  while (currentElement !== null) {
    const styles = window.getComputedStyle(currentElement);
    if (
      styles.display === "none" ||
      styles.visibility === "hidden" ||
      styles.opacity === "0"
    ) {
      return true;
    }

    currentElement = currentElement.parentElement;
  }

  return false;
};
